import taglineDarkUrl from '@/assets/brand/logo-with-tagline-dark.png';
import taglineUrl from '@/assets/brand/logo-with-tagline.png';
import wordmarkDarkUrl from '@/assets/brand/logo-without-tagline-dark.png';
import wordmarkUrl from '@/assets/brand/logo-without-tagline.png';
import { cn } from '@iq/ui';

export type BrandLogoVariant = 'wordmark' | 'tagline';

// Each variant's light + dark pair shares identical intrinsic dimensions, so the
// CSS swap below never shifts surrounding layout.
const VARIANTS: Record<BrandLogoVariant, { light: string; dark: string }> = {
  wordmark: { light: wordmarkUrl, dark: wordmarkDarkUrl },
  tagline: { light: taglineUrl, dark: taglineDarkUrl },
};

// Theme-aware brand logo. The toggle keys off the `.dark` class on <html> (set
// by ThemeProvider), which already resolves the `system` preference — no JS or
// re-render needed here. Exactly one variant is ever `display:block`, so
// assistive tech announces the logo once.
export function BrandLogo({
  className,
  variant = 'wordmark',
}: {
  className?: string;
  variant?: BrandLogoVariant;
}) {
  const { light, dark } = VARIANTS[variant];
  return (
    <>
      <img
        src={light}
        alt="InstaIQ Print Guard"
        draggable={false}
        className={cn('select-none dark:hidden', className)}
      />
      <img
        src={dark}
        alt="InstaIQ Print Guard"
        draggable={false}
        className={cn('hidden select-none dark:block', className)}
      />
    </>
  );
}
